export const TRANSLATIONS_TE = {
  login: {
    welcome: "స్వాగతం",
    username: "వినియోగదారు పేరు",
    password: "పాస్వర్డ్",
    usernamePlaceholder: "నమోదిత ఇమెయిల్ / వినియోగదారు పేరు",
    signIn: "సైన్ ఇన్ చేయండి",
    forgotPassword: "పాస్‌వర్డ్ మర్చిపోయాను",
    noAccount: "ఖాతా లేదా?",
    registerNow: "ఇప్పుడు నమోదు చేసుకోండి",
    noUsername: "దయచేసి మీ వినియోగదారు పేరును నమోదు చేయండి!",
    noPassword: "దయచేసి మీ పాస్‌వర్డ్‌ను ఇన్‌పుట్ చేయండి!",
  },
  register: {
    newUser: "కొత్త వినియోగదారు",
    registerHere: "ఇక్కడ నమోదు చేసుకోండి",
    email: "ఇమెయిల్",
    emailPlaceholder: "మీ నమోదిత ఇమెయిల్‌ను నమోదు చేయండి",
    mobileNo: "మొబైల్ నెం",
    createPassword: "పాస్వర్డ్ సృష్టించండి",
    confirmPassword: "పాస్‌వర్డ్‌ని నిర్ధారించండి",
    passwordAgain: "మరల పాస్వర్డ్ టైపు చేయండి",
    mobilePlease: "దయచేసి మొబైల్ నంబర్",
    signUp: "చేరడం",
    alreadyHaveAccount: "ఖాతా కలిగి ఉన్నారా!",
    signIn: "సైన్ ఇన్ చేయండి",
    noMobileNo: "దయచేసి మీ మొబైల్ నంబర్‌ని ఇన్‌పుట్ చేయండి!",
    noEmail: "దయచేసి మీ ఇమెయిల్‌ను ఇన్‌పుట్ చేయండి!",
    noPassword: "దయచేసి మీ పాస్‌వర్డ్‌ను ఇన్‌పుట్ చేయండి!",
    noConfirmPassword: "దయచేసి మీ కన్ఫర్మ్ పాస్‌వర్డ్‌ను ఇన్‌పుట్ చేయండి!",
  },
  verify: {
    title: "OTPతో ధృవీకరించండి",
    otpOn: "మేము OTPని పంపాము",
    registeredEmail: "మరియు మీ నమోదిత ఇమెయిల్ చిరునామా",
    codeNotReceived: "నేను కోడ్‌ని అందుకోలేదు.",
    resend: "మళ్లీ పంపండి",
    itOr: "ఇది లేదా",
    details: "వివరాలు",
    changeRegistrationDetails: "రిజిస్ట్రేషన్ వివరాలను మార్చండి",
    verify: "ధృవీకరించండి",
  },
};
